import { useState, React, useEffect } from "react";
import cardBoxImage from "../../assets/images/cardboxbg.png";
import Back from "../../assets/images/backbtn.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { fetchMeatCategory } from "../../services/livestock";
import AddLivestockServiceForm from "../../components/livestockService/livestockServiceForm";
import { createLivestockService } from "../../services/livestcokService";
import showNotification from "./../../components/notification/notification";
import { Button, Modal } from "react-bootstrap";

const AddLivestockService = () => {
  const navigate = useNavigate();
  const [menubuttons, setMenubuttons] = useState([]);
  const [selectedMenuButtons, setSelectedMenuButtons] = useState([]);
  const [show, setShow] = useState(false);
  const [opacity, setOpacity] = useState(1);
  const addLiveStockServiceFormik = useFormik({
    initialValues: {
      livestockServiceDetails: [],
    },
    onSubmit: async (values) => {
      if (values.livestockServiceDetails.length) {
        const res = await createLivestockService(values);
        if (res.status) {
          // alert("Log created successfully");
          navigate("/");
          showNotification(
            "Livestock Service data added successfully!",
            " success"
          );
        }
      } else {
        showNotification("Please select animal", "danger");
      }
    },
  });

  const getMeatCategory = async () => {
    const res = await fetchMeatCategory();
    if (res.status) {
      setMenubuttons(res.data);
    }
  };

  useEffect(() => {
    getMeatCategory();
  }, []);

  const onAnimalSelect = (button) => {
    console.log(button);
    const checkExist = selectedMenuButtons.some((x) => x === button._id);
    if (checkExist) {
      setSelectedMenuButtons(
        selectedMenuButtons.filter((value) => {
          return value !== button._id;
        })
      );
    } else {
      setSelectedMenuButtons([...selectedMenuButtons, button._id]);
    }
    const regionId = JSON.parse(localStorage.getItem("data")).regionDetails[0]
      ._id;
    let checkArrayExist =
      addLiveStockServiceFormik.values.livestockServiceDetails.some(
        (details) => details.liveStockId === button._id
      );
    if (checkArrayExist) {
      addLiveStockServiceFormik.setFieldValue(
        "livestockServiceDetails",
        addLiveStockServiceFormik.values.livestockServiceDetails.filter(
          (value) => {
            return value.liveStockId !== button._id;
          }
        )
      );
    } else {
      addLiveStockServiceFormik.setFieldValue("livestockServiceDetails", [
        ...addLiveStockServiceFormik.values.livestockServiceDetails,
        {
          regionId: regionId,
          liveStockId: button._id,
          animalTypeName: button.name,
          ai: "",
          castrations: "",
          trimmingHooves: "",
          dehorns: "",
          dockingTails: "",
          clippingTeeth: "",
          debeaking: "",
        },
      ]);
    }
  };

  const reset = () => {
    let tempArray = [
      ...addLiveStockServiceFormik.values.livestockServiceDetails,
    ];

    setSelectedMenuButtons([]);
    tempArray.forEach((element) => {
      element.ai = "";
      element.trimmingHooves = "";
      element.dehorns = "";
      element.dockingTails = "";
      element.clippingTeeth = "";
      element.debeaking = "";
      element.castrations = "";
    });
    addLiveStockServiceFormik.setFieldValue("livestockServiceDetails", []);
  };

  const changeFormValue = (index, value, changeKey) => {
    let tempArray = [
      ...addLiveStockServiceFormik.values.livestockServiceDetails,
    ];
    tempArray[index][`${changeKey}`] = value;
    addLiveStockServiceFormik.setFieldValue(
      "livestockServiceDetails",
      tempArray
    );
  };
  const goBack = () => {
    navigate(-1);
  };
  const addUserReset = () => {
    reset();
    setShow(false);
    setOpacity(0);
  };
  const handleClose = () => {
    setShow(false);
    setOpacity(0);
  };
  const handleShow = () => {
    setShow(true);
    setOpacity(1);
  };
  return (
    <div className="theme-container">
      <div className="contentCard2">
        <div className="contentCardHeader addProdctHeader">
          <h3>Add Livestock Service</h3>
          <button onClick={goBack}>
            <img
              src={Back}
              alt=""
            />{" "}
            Back
          </button>
        </div>
        <div className="cardbg">
          <img
            src={cardBoxImage}
            alt="card bg"
          />
        </div>
      </div>
      {/* -------------------Form---------------------- */}
      <form onSubmit={addLiveStockServiceFormik.handleSubmit}>
        <div className="politryStockForm">
          <div className="politryStock">
            <div className="AddprodRow1Egg">
              <div className="eggLogFarmer">
                <div className="farmersBox">
                  Animal Type
                  <div className="buttons">
                    {menubuttons &&
                      menubuttons[0]?.productCategories?.map(
                        (button, index) => {
                          return (
                            <button
                              key={index}
                              type="button"
                              className={`${
                                selectedMenuButtons?.some(
                                  (x) => x === button._id
                                )
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() => onAnimalSelect(button)}>
                              {button.name}
                            </button>
                          );
                        }
                      )}
                  </div>
                </div>
              </div>
            </div>
            {addLiveStockServiceFormik?.values?.livestockServiceDetails.map(
              (value, index) => {
                return (
                  <AddLivestockServiceForm
                    index={index}
                    formData={value}
                    changeFormValue={changeFormValue}
                  />
                );
              }
            )}
          </div>
          {addLiveStockServiceFormik.values.livestockServiceDetails.length ? (
            <div className="bottomButtons">
              <button
                type="submit"
                className="addprdt active"
                id="addprdt">
                Add Livestock Service
              </button>
              <button
                type="reset"
                className="reset"
                id="rst"
                onClick={handleShow}>
                {" "}
                Reset
              </button>
            </div>
          ) : (
            <div className="select-animal-type">
              {" "}
              <p>Please Select Animal </p>
            </div>
          )}
        </div>
      </form>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        style={{ opacity: opacity }}>
        <Modal.Header closeButton>
          <Modal.Title> Reset?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}>
            No
          </Button>
          <Button
            variant="primary"
            onClick={addUserReset}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddLivestockService;
